exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".withdrawal_management[data-v-1e27ad4e]{padding:20px 20px 40px 20px}.title[data-v-1e27ad4e]{font-size:20px;font-weight:600}.search_criteria[data-v-1e27ad4e]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-top:10px}.search_criteria>div[data-v-1e27ad4e]{margin:0 5px;width:180px}[data-v-1e27ad4e] .el-dropdown__caret-button{height:100%}.w100[data-v-1e27ad4e]{width:100%}.page_box[data-v-1e27ad4e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.page_box[data-v-1e27ad4e]  .el-pagination__jump{margin-left:0px}", ""]);

// exports
